import { render } from "./Estados.vue?vue&type=template&id=51ea039c&scoped=true"
import script from "./Estados.vue?vue&type=script&lang=js"
export * from "./Estados.vue?vue&type=script&lang=js"

import "./Estados.vue?vue&type=style&index=0&id=51ea039c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Josue\\Documents\\IMSS\\CDI\\SITE\\frontrdsyuc\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51ea039c"]])

export default __exports__